import React, { useContext, useEffect, useState } from 'react';
import {
  FinanceInformationTwoRowLabel,
  FinanceInformationTwoRowNoElements,
  FinanceInformationTwoRowText,
  FinanceInformationTwoRowIcon,
  CentralInformationRowLabel,
  FinanceInformationTwoHide
} from './styles';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router';
import { currencyMoney, currencyMoneyCents } from '../../../config/currency';
import InputIntl from '../../../components/InputIntl';
import Select from '../../../components/Select';
import InputDate from '../../../components/InputDate';
import InputDefault from '../../../components/InputDefault';
import InputFile from '../../../components/InputFile';
import FormTemplate from '../../../components/FormTemplate';
import { useDropzone } from 'react-dropzone';
import { getDocumentTypes } from '../../../services/document';
import { saveGlobalDebt } from '../../../services/globalDebt';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { globalDebtSteps, mortagePayments } from '../../../helpers/enum';
import { getFinancialCommitmentsByCreditId } from '../../../services/financialCommitments';
import { GlobalDebtContext, SessionContext } from '../../../store';
import { formatDateToDefaultUS } from '../../../helpers/date';
import { default as GlobalDebtTypes } from '../../../store/GlobalDebt/types';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import Loader from '../../../components/LoaderDebt';
import { BsExclamation, BsInfo } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import ModalAction from '../../../components/ModalAction';
import { InfoCircleImage, Tooltip, TooltipContent, TooltipTitle } from '../../Simulator/PriceValueToSolicitate/styles';
import infoCircle from '../../../assets/images/info-circle.svg';
import { postAnnularCreditById, saveCreditAnulacion } from '../../../services/credit';

const FinanceInformationOnePage = ({ setActiveStep, setLastStep }) => {
  const session = useContext(SessionContext);
  const history = useHistory();
  const { globalDebt, setGlobalDebt } = useContext(GlobalDebtContext);
  const [canAddFile, setCanAddFile] = useState(true);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  const { setValue, errors, control, register, handleSubmit, clearErrors } = useForm({ defaultValues: globalDebt.financeInformationOne });
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [showDocumentTypes, setShowDocumentTypes] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showErrorNegativeModal, setShowErrorNegativeModal] = useState(false);

  async function initializedStateComponent() {
    try {
      console.log("descuentosLey: "+globalDebt.solicitation.simulacion.descuentosLey)
      console.log("descuentosNomina: "+globalDebt.solicitation.simulacion.descuentosNomina)
      const responseDocuments = await getDocumentTypes('ENDEUDAMIENTO_GLOBAL');
      setDocumentTypes(responseDocuments.data);
      setIsLoading(false);
    } catch(error) {
      
    }
  }

  function isEmptyFinancialCommitmentsResponse(response) {
    return !response.data || !(
      response.data.tarjetasCredito !== null && response.data.tarjetasCredito !== undefined && 
      response.data.creditosRotativos !== null && response.data.creditosRotativos !== undefined && 
      response.data.creditosHipotecarios !== null && response.data.creditosHipotecarios !== undefined &&
      response.data.cuotasHipotecarias !== null && response.data.cuotasHipotecarias !== undefined && 
      response.data.puntajeCifin !== null && response.data.puntajeCifin !== undefined);
  }

  async function setCompleteStep(data) {
    try {
      console.log(JSON.stringify(data))
      data.descuentosNomina = data.descuentosNomina? data.descuentosNomina : 0
      data.descuentosPrestacionales = data.descuentosPrestacionales? data.descuentosPrestacionales : 0
      setIsLoading(true);
      setGlobalDebt({
        type: GlobalDebtTypes.SET_FINANCE_INFORMATION_ONE,
        data: data
      })

  
        
      const responseFinancial = await getFinancialCommitmentsByCreditId(globalDebt.credit.id);

      if(isEmptyFinancialCommitmentsResponse(responseFinancial)) {
        setIsLoading(false);
        setShowErrorModal(true);
      } else {
        await setGlobalDebt({
          type: GlobalDebtTypes.SET_FINANCIAL_COMMITMENTS,
          financialCommitments: responseFinancial.data
        })
         /* En caso de que no se seteen los valores */
        if(data.cuotasHipotecarias === undefined) {
          data.cuotasHipotecarias = getMortgagePaymentsDefaultValue();
          if(data.cuotasHipotecarias == 0) data.cuotasHipotecarias = 1;
        }
        if(data.otrasCuotasSectorFinanciero === undefined) {
          data.otrasCuotasFinancieras = getOtherFinancialPaymentsDefaultValue();
        }
        setGlobalDebt({
          type: GlobalDebtTypes.SET_MORTGAGE_PAYMENT,
          cuotasHipotecarias: data.cuotasHipotecarias
        })

        const response = await saveDataGlobalDebt(globalDebt, false);
        
        setGlobalDebt({
          type: GlobalDebtTypes.SET_GLOBAL_DEBIT_CALCULATION,
          calculation: response.data
        })
      
        if(response.data.ingresosFaltantesAproximadosEndeudamiento < 1) {
          await saveDataGlobalDebt(globalDebt, true);

          setIsLoading(false);
          history.push({
            pathname: '/admin/means-of-disbursement',
            idCredit: globalDebt.credit.id,
          });
        } else {
          await saveDataGlobalDebt(globalDebt, true);
          setIsLoading(false);
          setShowErrorNegativeModal(true);
          //setActiveStep(globalDebtSteps.OTHER_CERTIFIED_INCOME);
        }
      }
    } catch(error) {
      setIsLoading(false);
      console.log(error)
    }
  }

  async function saveDataGlobalDebt(globalDebt, save) {
    const req = new FormData();
    req.append('save', save);
    req.append('archivo', globalDebt.centralInformation.archive[0], globalDebt.centralInformation.archive[0].name);
    req.append('idCredito', globalDebt.credit.id);
    req.append('idEstrato', globalDebt.basicRequestInformation.estrato.id);
    req.append('idTipoVivienda', globalDebt.basicRequestInformation.tipoVivienda.id);
    req.append('idClaseVivienda', globalDebt.basicRequestInformation.claseVivienda.id);
    req.append('idParentesco', globalDebt.basicRequestInformation.posicionHogar.id);
    req.append('idNivelEducativo', globalDebt.basicRequestInformation.nivelEscolaridad.id);
    req.append('descuentosPrestacionales',globalDebt.solicitation.simulacion.descuentosLey);
    req.append('descuentosNomina', globalDebt.solicitation.simulacion.descuentosNomina);
    req.append('cuotasHipotecariasCentrales', parseFloat(globalDebt.centralInformation.cuotasHipotecarias));
    //req.append('codigoAdo', globalDebt.basicRequestInformation.adoSegmentCode);
    req.append('idDocumento', globalDebt.centralInformation.tipoDocumento.id);
    req.append('subCanal', "WEB");

    const response = await saveGlobalDebt(req);
    return response;
  }

  async function anularCredito() {
    const data = {
      asesorId: session.idAsesor,
      creditoId: globalDebt.credit.id,
      causalId: 839,
      estadoNegar: "NEGADO"
    }
    await saveCreditAnulacion(data);
    history.push('/admin/dashboard')
  }

  function selectDocumentType(documentType) {
    setValue("tipoDocumento", documentType);
    clearErrors("tipoDocumento", {});

    setGlobalDebt({
      type: GlobalDebtTypes.SET_DOCUMENT_TYPE,
      tipoDocumento: documentType
    })
  }
  
  function removeFile() {
    setGlobalDebt({
      type: GlobalDebtTypes.REMOVE_ARCHIVE,
      file: []
    })
  }

  function onDrop(file) {
    setGlobalDebt({
      type: GlobalDebtTypes.SET_ARCHIVE,
      file
    })
  }

  function areMortgagePaymentsPresent() {
    return globalDebt.centralInformation.financialCommitments.creditosHipotecarios.length > 0;
  }

  function getMortgagePaymentsValue() {
    var initialValue = 0;
    globalDebt.centralInformation.financialCommitments.creditosHipotecarios.forEach((credito) => { initialValue += credito.valorCuota });
    initialValue = Math.min(initialValue, mortagePayments.max);
    return initialValue;
  }

  function getMortgagePaymentsDefaultValue() {
    return areMortgagePaymentsPresent() ? getMortgagePaymentsValue() : mortagePayments.min;
  }

  function getMortgagePaymentCountValue() {
    return globalDebt.centralInformation.financialCommitments.cuotasHipotecarias || 0;
  }

  function getOtherFinancialPaymentsDefaultValue() {
    return globalDebt.centralInformation.financialCommitments.otrasCuotasFinancieras || 0;
  }

  useEffect(() => {
    setIsLoading(false);
    initializedStateComponent();
    globalDebt.centralInformation.financialCommitments.creditosHipotecarios.map((item, key) => {
      const newDate = formatDateToDefaultUS(item.fechaDesembolso);
      setValue(`fechaDesembolso${key+1}`, newDate);
      setValue(`cuotasPendientes${key+1}`, item.cuotasPendientes);
    })
  }, [])

  useEffect(() => {
    if (globalDebt.centralInformation.archive.length < 1) {
      setCanAddFile(true)
    } else {
      setCanAddFile(false)
    }
  }, [globalDebt.centralInformation.archive])


  return (
    <FormTemplate 
      idForm="finance-information-one-step-lage"
      activeStep="2/2"
      stepLabel="Información financiera y centrales"
      idCredito={globalDebt.credit.id}>
      <Form onSubmit={handleSubmit(setCompleteStep)} id="form">
        <FormRow col="1">
          <InputIntl
            id="descuentosPrestacionales"
            label={<div>Total descuentos de ley<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-descuentos-ley' /></div>}
            error={errors.descuentosPrestacionales}
            name="descuentosPrestacionales"
            defaultValue={globalDebt.solicitation.simulacion.descuentosLey}
            setValue={setValue}
            currencyConfig={currencyMoney}
            readOnly
            register={register({ 
              min: {
                value: 0,
                message: "Este dato es obligatorio" 
              }
            })} />
        </FormRow>
        <Tooltip
                id='tooltip-descuentos-nomina'
                effect="solid"
                place='top'
                border
                multiline
                textColor='#05443D'
                borderColor='#25BBAB'>
                <TooltipTitle>
                  Total otros descuentos de nómina
                </TooltipTitle>
                <TooltipContent>
                  Deducciones que se aplican al cliente cuando se le efectúa su pago laboral.
                </TooltipContent>
              </Tooltip>
        <FormRow col="1">
          <InputIntl
            id="descuentosNomina"
            label={<div>Total otros descuentos de nómina<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-descuentos-nomina' /></div>}
            error={errors.descuentosNomina}
            name="descuentosNomina"
            defaultValue={globalDebt.solicitation.simulacion.descuentosNomina}
            setValue={setValue}
            currencyConfig={currencyMoney}
            readOnly
            register={register({ 
              min: {
                value: 0,
                message: "Este dato es obligatorio" 
              }
            })} />
        </FormRow>
        <Tooltip
          id='tooltip-descuentos-ley'
          effect="solid"
          place='top'
          border
          multiline
          textColor='#05443D'
          borderColor='#25BBAB'>
          <TooltipTitle>
            Total descuentos de ley
          </TooltipTitle>
          <TooltipContent>
            Deducciones que se aplican al cliente por aportes a salud y pensión.
          </TooltipContent>
        </Tooltip>


          <FinanceInformationTwoHide>
        {
          globalDebt.centralInformation.financialCommitments.tarjetasCredito && globalDebt.centralInformation.financialCommitments.tarjetasCredito.length > 0 ?
          <FormRow col="2">
            {globalDebt.centralInformation.financialCommitments.tarjetasCredito.map((card, key) => (
              <InputIntl
                key={key}
                id={`tarjetaCredito${key+1}`}
                label={`Tarjeta de crédito ${key+1}`}
                name={`tarjetaCredito${key+1}`}
                defaultValue={card}
                register={register}
                setValue={setValue}
                currencyConfig={currencyMoney}
                disabled />
              ))}
          </FormRow> :
          <FinanceInformationTwoRowNoElements>
            <FinanceInformationTwoRowIcon>
              <BsInfo size={20} color={colors.bgPrimary} id="no-credit-cards-icon" />
            </FinanceInformationTwoRowIcon>
            <FinanceInformationTwoRowText>El cliente no posee tarjetas de crédito</FinanceInformationTwoRowText>
          </FinanceInformationTwoRowNoElements>
        }
        {
          globalDebt.centralInformation.financialCommitments.creditosRotativos && globalDebt.centralInformation.financialCommitments.creditosRotativos.length > 0 ?
          <FormRow col="1">
            {globalDebt.centralInformation.financialCommitments.creditosRotativos.map((card, key) => (
              <InputIntl
                key={key}
                id={`creditoRotativo${key+1}`}
                label={`Crédito Rotativo ${key+1}`}
                name={`creditoRotativo${key+1}`}
                defaultValue={card}
                register={register}
                setValue={setValue}
                currencyConfig={currencyMoney}
                disabled />
              ))}
          </FormRow> :
          <FinanceInformationTwoRowNoElements>
            <FinanceInformationTwoRowIcon>
              <BsInfo size={20} color={colors.bgPrimary} id="no-rotative-credits-icon" />
            </FinanceInformationTwoRowIcon>
            <FinanceInformationTwoRowText>El cliente no tiene registrado créditos rotativos</FinanceInformationTwoRowText>
          </FinanceInformationTwoRowNoElements>
        }
        {globalDebt.centralInformation.financialCommitments.creditosHipotecarios.length ? <FinanceInformationTwoRowLabel>Crédito hipotecario</FinanceInformationTwoRowLabel> : ''}
        {(globalDebt.centralInformation.financialCommitments.creditosHipotecarios && globalDebt.centralInformation.financialCommitments.creditosHipotecarios || []).map((card, key) => (
          <div key={key}>
            <FormRow col="2">
              <InputDate
                aria-required
                type="date"
                label="Fecha de desembolso"
                name={`fechaDesembolso${key+1}`}
                id={`fechaDesembolso${key+1}`}
                register={register}
                error={errors.fechaDesembolso}
                onBlur={() => { }}
                readOnly />
              <Controller
                as={InputDefault}
                control={control}
                label="Cuotas pendientes"
                name={`cuotasPendientes${key+1}`}
                id={`cuotasPendientes${key+1}`}
                register={register}
                error={errors.cuotasPendientes}
                defaultValue={globalDebt.centralInformation.financialCommitments.creditosHipotecarios[key].cuotasPendientes}
                readOnly />
            </FormRow>
            <FormRow col="2">
              <InputIntl
                name={`valorInicial${key+1}`}
                id={`valorInicial${key+1}`}
                error={errors.valorInicial}
                label="Valor Inicial"
                register={register}
                defaultValue={card.valorInicial}
                setValue={setValue}
                currencyConfig={currencyMoney}
                disabled />
              <InputIntl
                name={`valorCuota${key+1}`}
                id={`valorCuota${key+1}`}
                error={errors.valorCuota}
                label="Valor de cuota"
                register={register}
                defaultValue={card.valorCuota}
                setValue={setValue}
                currencyConfig={currencyMoney}
                disabled />
            </FormRow>
          </div>
        ))}</FinanceInformationTwoHide>


        <FormRow col="1">

          <Select
            error={errors.tipoDocumento}
            setShow={setShowDocumentTypes}
            show={showDocumentTypes}
            defaultValue={globalDebt.centralInformation.tipoDocumento.nombre}
            setSelected={selectDocumentType}
            list={documentTypes}
            placeholder="Seleccionar..."
            label="Tipo documento"
            name="tipoDocumento"
            register={register({ required: "Este dato es obligatorio" })}
            id="tipoDocumento" />
        </FormRow>
        <CentralInformationRowLabel>Desprendible de nómina u otro</CentralInformationRowLabel>
        <FormRow col="1">
          <InputFile
            getInputProps={getInputProps}
            getRootProps={getRootProps}
            canAddFile={canAddFile}
            files={globalDebt.centralInformation.archive}
            removeFile={removeFile}
            description="Elige un archivos PNG, JPEG o JPG, o arrasta aqui." />
        </FormRow>





        
        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" id="back-step" onClick={() => setActiveStep(globalDebtSteps.BASIC_REQUESTING_INFORMATION)}>Volver</DefaultLargeButton>
          <SecondaryLargeButton type="submit" id="submit">Siguiente </SecondaryLargeButton>
        </FormFooter>
        {isLoading && <Loader />}
      </Form>
      <ModalAction
        open={showErrorModal}
        setShowModal={setShowErrorModal}
        actionFunctionUpButton={() => history.push('/admin/dashboard')}
        title="Error de endeudamiento global"
        actionLabelFunctionUpButton="Ir al inicio"
        description={"No se pudo obtener la información financiera del crédito. No se podrá continuar con la operación."}
        backgroundIcon={colors.textHyperlink}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="api-error-exclamation-icon" />} />
        <ModalAction
        open={showErrorNegativeModal}
        actionFunctionUpButton={anularCredito}
        title="El cliente cuenta con un nivel de endeudamiento global que supera sus ingresos. Cuidando el bienestar financiero de nuestros clientes, la solicitud no puede continuar a la siguiente etapa."
        actionLabelFunctionUpButton="Continuar"
        backgroundIcon={colors.bgTertiary}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="api-error-exclamation-icon" />} />
    </FormTemplate>
  )
}

export default FinanceInformationOnePage
